import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import EditCustomFieldModalBody from './components/EditCustomFieldModalBody'
import { useCustomFieldPageContext } from '../../CustomFieldPageContext'
import { useUserRoleSelectContext } from 'components/CIMSSelect/common/UserRoleSelect/UserRoleSelectContext'
import { EditCustomFieldModalBodyValues } from './components/EditCustomFieldModalBody/types'
import { ProjectCustomField } from 'components/CustomFields/ProjectCustomFieldsContext/types'

export function useEdit() {
  const { toLabeledValues } = useUserRoleSelectContext()
  const { edit, toInputs } = useCustomFieldPageContext()
  const { refetch } = useProjectCustomFieldsContext()

  const options: EditRowActionOptions<
    ProjectCustomField,
    EditCustomFieldModalBodyValues
  > = {
    permission: Permission.EditCustomField,
    modal: {
      initialValues: ({
        dataTypeId,
        metadata: { entityIds, styleId, reportIds },
        name,
        description,
        customListItems,
        customFieldToClassTypes,
      }) => ({
        dataTypeId,
        name,
        description,
        styleId,
        reportIds,
        entityIds,
        customListItems: customListItems.map(({ id, value }) => ({
          id,
          value,
        })),
        customFieldToClassTypes: customFieldToClassTypes.map<
          EditCustomFieldModalBodyValues['customFieldToClassTypes'][0]
        >(
          ({
            alwaysEditable,
            classTypeId,
            prominent,
            required,
            roles,
            users,
          }) => ({
            editors: toLabeledValues({ users, roles }),
            alwaysEditable,
            classTypeId,
            prominent,
            required,
          })
        ),
      }),
      recordName: 'name',
      onOk: async (
        { id },
        {
          name,
          description,
          customListItems,
          entityIds,
          reportIds,
          customFieldToClassTypes,
        }
      ) => {
        await edit.fn({
          variables: {
            editCustomFieldInput: {
              id,
              name,
              description,
              customListItems,
              metadata: { entityIds, reportIds },
              customFieldToClassTypeInputs: toInputs(customFieldToClassTypes),
            },
          },
        })
        refetch()
      },
      body: ({ dataTypeId, customFieldToClassTypes }) => (
        <EditCustomFieldModalBody
          dataTypeId={dataTypeId}
          customFieldToClassTypes={customFieldToClassTypes}
        />
      ),
    },
  }

  return options
}
